module.exports = ["STATISTICS","QRCODE","SURVEYS","CONVERSION","RUBIX"];